module.exports = __webpack_public_path__ + "img/touxiang.0cd8ffb8.jpg";